import * as React from "react";

interface PropsType {
  text: string;
  successCallback?: (info: any) => void;
}

import IconButton from "../IconButton/index";

function CopyToClipboardButton(props: PropsType) {
  function copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
  }

  function handleClick() {
    copyToClipboard(props.text);
    typeof props.successCallback === "function" &&
      props.successCallback({
        operation: "COPY",
      });
  }

  return (
    <IconButton
      label="Copy"
      icon="CopytoClipboardIcon"
      handleClick={handleClick}
    />
  );
}

export default CopyToClipboardButton;
